import { Helmet } from "react-helmet";
import "./global.css";
import Contact from "./Contact";
import { motion } from 'framer-motion';
const services = [
  {
    icon: 'fas fa-user-cog',
    title: 'Mechanic',
  },
  {
    icon: 'fas fa-bolt',
    title: 'Electrician',
  },
  {
    icon: 'fas fa-paint-roller',
    title: 'Car Painter',
  },
  {
    icon: 'fas fa-car',
    title: 'Car Detailing',
  },
  {
    icon: 'fas fa-hammer',
    title: 'Car Dent Removal',
  },
];
export default function Home() {
  return (
    <>
      <Helmet>
        <title>Fakhar Autos Works - Professional Auto Repair Services</title>
        <meta name="description" content="Quality auto repair services for all types of vehicles." />
      </Helmet>

      <div class="container-fluid d-flex justify-content-center home" >
        <div class="row w-100">
          <div class="col-lg-12">
            <div class=" hero-home px-4 d-flex align-items-center bg-light rounded-4 border" style={{boxShadow: "6px 6px 12px #c5c5c5,-6px -6px 12px #ffffff"}}>
              <div class="row align-items-center">
                <div class="col-md-6">
                  <h1 class="display-3" style={{ fontWeight: "bold" }}>We Repair ALL KINDS OF CARS!</h1>
                  <p class="lead">
                    Get expert car repair and maintenance services at Fakhar Autos
                    Workshop. Our team of skilled technicians provides top-notch
                    solutions for all your vehicle needs in Islamabad.
                  </p>
                  <a
                    href="#services"
                    class="btn home-btn btn-lg mt-3"
                    role="button"
                  >
                    Learn More
                  </a>
                </div>
                <div class="col-md-6 ">
                  <img
                    src="car.png"
                    alt="Car with open hood"
                    class="img-fluid"
                    style={{ filter: "drop-shadow(10px 10px 10px rgba(0, 0, 0, 0.3))" }}
                  />
                </div>  
              </div>
            </div>
          </div>
        </div>
      </div>

        <div class="col-lg-12 services-section" style={{overflow: "hidden"}}>
          <h3 class="text-center py-8">Our Services</h3>
          <div class="services-list d-flex justify-content-center align-items-center row">
            {services.map((service) => (
              <motion.button
                icons={service.icon}
                key={service.title}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                class="btn btn-outline-secondary col-lg-3 mb-2 mx-2 services-item"
                style={{ fontSize: "2rem", borderRadius: "10px" }}
              >
                <div class="d-flex flex-column align-items-center">
                  <i class={service.icon} style={{ fontSize: "4rem", }}></i>
                  <h4 class="mb-0 ">{service.title}</h4>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
        
      <section className="about-us">
        <div className="container">
          <div className="about-us-content">
            <div className="about-us-text">
              <h2 className="title">About Us</h2>
              <p className="description">
                At Fakhar Autos Works, we pride ourselves on delivering top-notch auto repair services. Our team of skilled professionals is dedicated to ensuring your vehicle is in peak condition, providing you peace of mind on the road.
              </p>
              <a href="/about" className="btn about-btn">Read More</a>
            </div>
            <div className="about-us-image">
              <img src="/img.jpg" alt="Fakhar Autos Works" />
            </div>
          </div>
        </div>
      </section>
      
      
      
      <Contact />
      <style jsx>{`
    
.active {
  color: #9a0002 !important;
}
  .contact {
    color: inherit !important;

    }

  `}</style>
    </>
  );
}
